var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.6641,
    height: 12.7687,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.38562,
    y: 2.40039,
    width: 8,
    height: 8,
    rx: 1,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1712_5213",
    transform: "matrix(0.00787705 0 0 0.0078125 -0.00413148 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1712_5213",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAA3NCSVQICAjb4U/gAAAACXBIWXMAACaEAAAmhAGgBivRAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAJlQTFRF////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvrCY7gAAADJ0Uk5TAAECBAUOERgmKCktLj9BREVGVlhaYnZ4eXt/hp+wsrO0uMbHyczNztHS1Nbb6/b5+v5EouVcAAACBUlEQVR42u2buXbCMBREx8SsgSTsMQbMGnYC+v+PS5GcJOiJpbD0mplSLuYe29JTMQO4VO6mw+nmcDa56HzYTIdpt4wHVenNcnK2OGa9yn33qLU1HrVtRbf9GwvjWYvGDftaZgIoq13zbx9NEB3bTvtCaoIpLUj/YmYCKisK/40Jqo1FUMhMYGWXXyE1wZVe/P9GQf/2Qu2oAXD8Ow8yo6Ls9/w1Svo5laOFFsDiezK1rj3fj0e5aLy/5tACADjn7zpplpCbSs1k7ZzOAFBxPDgNYuSseHByGFUA9OTyqg4Pqq+kUw/ATPrH8KJYEsyAsrj/nerwpLr4CucyuoJqAG8aCLOuHEPr2B9AvJYjaWgvJfCoxHYbYmovNX0CvNluU4ibUMknQEncjHCwz194lX0qH2DvwrFfgLG9D2G/k5FfgJHtRwACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAALoA6jHeNSDTIGjXGcR5QobZnuVYbawcb53GecLGmh8WslAY9BIZ+KIdIYMtT5/OkKtmIeL9X64Yr3oawebq9rRbuyUw+3oaMf7o6VywQEvyhUPYKJcctGv+agXnfSrXvplN/W6n37hUb/yCfXSK0LVfie1G2PLf/F5+XJ7cHqufu860f3h7a38Pu9XH71ABKz/fwF5mjUXSZWBFwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/Selected.ba0841ab8967a774dcd591ec0936c06e.svg";
export { ForwardRef as ReactComponent };